import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { SERVER_URL } from './ServerConfig';
import { Modal, Button } from 'react-bootstrap';
import queryString from 'query-string';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class InvertersTable extends Component {

    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: true,
            station: {},
            inverters: [],

            pendingAddInverter: false,
            addInverterName: "",
            addInverterIP: "",
            addInverterMessage: "",

            editInverter: null,
            pendingEditInverter: false,
            updatingEditInverter: false,
            editInverterName: "",
            editInverterIP: "",
            editInverterPowerOutput: "",
            editInverterMessage: "",

            deleteInverter: null,
            pendingDeleteInverter: false,
            deleteInverterMessage: '',
            params: params
        }
        this.connections = []

        this.handleOpenAddInverterDialog = this.handleOpenAddInverterDialog.bind(this);
        this.handleAddInverter = this.handleAddInverter.bind(this);
        this.handleCloseAddInverter = this.handleCloseAddInverter.bind(this);
        this.handleAddInverterName = this.handleAddInverterName.bind(this);
        this.handleAddInverterIP = this.handleAddInverterIP.bind(this);

        this.handleOpenEditInverterDialog = this.handleOpenEditInverterDialog.bind(this);
        this.handleEditInverter = this.handleEditInverter.bind(this);
        this.handleCloseEditInverter = this.handleCloseEditInverter.bind(this);
        this.handleEditInverterName = this.handleEditInverterName.bind(this);
        this.handleEditInverterIP = this.handleEditInverterIP.bind(this);
        this.handleEditInverterPowerOuput = this.handleEditInverterPowerOuput.bind(this);

        this.handleOpenDeleteInverterDialog = this.handleOpenDeleteInverterDialog.bind(this);
        this.handleCloseDeleteInverterDialog = this.handleCloseDeleteInverterDialog.bind(this);
        this.handleDeleteInverter = this.handleDeleteInverter.bind(this);
    }

    notify = () => {
        toast.success("Power output has been updated!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    componentDidMount() {
        this.fetchStation();
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    fetchStation() {
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        fetch(SERVER_URL + '/v1/stations/' + stationId, {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    let station = data.content;
                    this.fetchInverters(station, token, true);
                }
            });
    }

    isOwner() {
        let user = this.props.user.payload.user;
        return user.member.mRole === 'owner';
    }

    fetchInverters(station, token, repeat) {
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/inverters_current', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (this.unmounted) {
                    return;
                }
                if (repeat) {
                    this.interval = setInterval(() => this.doFetchInterval(station, token), 5000);
                }
                this.setState({ isLoading: false, station: station, inverters: data.content });
            })
    }


    doFetchInterval(station, token) {
        clearInterval(this.interval);
        this.fetchInverters(station, token, true);
    }

    getBody(inverters) {
        if (this.state.isLoading) {
            return null;
        } else {
            return inverters.map((item, idx) => {
                return this.getItems(item, idx);
            })
        }
    }

    handleAddInverter(event) {
        if (!this.state.addInverterName || !this.state.addInverterIP) {
            return;
        }

        const station = this.state.station;
        const token = this.props.user.payload.token;

        let body = {
            name: this.state.addInverterName,
            IP: this.state.addInverterIP
        }

        fetch(SERVER_URL + '/v1/stations/' + station._id + '/createInverter', {
            method: 'post',
            headers: {
                'x-access-token': token,
                'content-type': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    this.setState({ pendingAddInverter: false, addInverterMessage: "" });
                    this.fetchInverters(this.state.station, token, false);
                } else {
                    this.setState({ addInverterMessage: data.message });
                }
            })
    }

    checkInverterPowerOutputUpdated() {
        const station = this.state.station;
        const token = this.props.user.payload.token;
        fetch(SERVER_URL + '/v1/inverters/' + this.state.editInverter._id + '/get', {
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        }).then(data => {
            if (data.content && data.content.mPowerOutput !== parseInt(this.state.editInverterPowerOutput)) {
                setTimeout(() => {
                    let now = moment();
                    let duration = now.diff(this.state.startUpdateTime, 'seconds');
                    if (duration < 10) {
                        this.checkInverterPowerOutputUpdated();
                    } else {
                        this.setState({ updatingEditInverter : false, editInverterMessage: "Could not update power output" });
                    }
                }, 1000);
            } else {
                this.notify();
                this.setState({ updatingEditInverter : false, pendingEditInverter: false, editInverterMessage: "", editInverter: null });
                this.fetchInverters(this.state.station, token, false);
            }
        })
    }

    handleEditInverter(event) {
        if (!this.state.editInverterName || !this.state.editInverterIP || !this.state.editInverterPowerOutput
            || (this.state.editInverter 
                && this.state.editInverterName === this.state.editInverter.mName 
                && this.state.editInverterIP === this.state.editInverter.mIP
                && this.state.editInverterPowerOutput === this.state.editInverter.mPowerOutput)) {
            return;
        }

        const station = this.state.station;
        const token = this.props.user.payload.token;
        let sameIP = this.state.editInverterIP === this.state.editInverter.mIP
        let sameOutput = this.state.editInverterPowerOutput === this.state.editInverter.mPowerOutput;

        this.setState({updatingEditInverter : true });

        let body = {
            name: this.state.editInverterName,
            IP: this.state.editInverterIP,
            powerOutput : this.state.editInverterPowerOutput,
            sameIP: sameIP
        }

        fetch(SERVER_URL + '/v1/inverters/' + this.state.editInverter._id + '/update', {
            method: 'post',
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    if (sameOutput) {
                        this.setState({ updatingEditInverter: false, pendingEditInverter: false, editInverterMessage: "", editInverter: null });
                        this.fetchInverters(this.state.station, token, false);
                    } else {
                        let now = moment();
                        this.setState({ startUpdateTime : now });
                        this.checkInverterPowerOutputUpdated();
                    }
                } else {
                    this.setState({ updatingEditInverter: false, editInverterMessage: data.message });
                }
            })
    }

    handleDeleteInverter(event) {
        const token = this.props.user.payload.token;
        const inverter = this.state.deleteInverter;

        fetch(SERVER_URL + '/v1/inverters/' + inverter._id + "/delete", {
            method: 'delete',
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    this.setState({ pendingDeleteInverter: false, deleteInverter: null });
                    this.fetchInverters(this.state.station, token, false);
                } else {
                    this.setState({ deleteInverterMessage: data.message });
                }
            })
    }

    handleOpenAddInverterDialog(event) {
        this.setState({ pendingAddInverter: true, addInverterName: "", addInverterIP: "", addInverterMessage: "" });
    }

    handleOpenEditInverterDialog(event, inverter) {
        if (!inverter.mPowerOutput) {
            inverter.mPowerOutput = 100;
        }
        this.setState({ pendingEditInverter: true, editInverter: inverter, editInverterName: inverter.mName, editInverterIP: inverter.mIP, 
            editInverterPowerOutput: inverter.mPowerOutput, editInverterMessage: "" });
    }

    handleOpenDeleteInverterDialog(event, inverter) {
        this.setState({ pendingDeleteInverter: true, deleteInverter: inverter, deleteInverterMessage: "" });
    }

    handleCloseAddInverter(event) {
        this.setState({ pendingAddInverter: false });
    }

    handleCloseEditInverter(event) {
        this.setState({ pendingEditInverter: false, editInveter: null });
    }

    handleCloseDeleteInverterDialog(event) {
        this.setState({ pendingDeleteInverter: false, deleteInverter: null });
    }

    handleAddInverterName(event) {
        let name = event.target.value;
        this.setState({ addInverterName: name });
    }

    handleAddInverterIP(event) {
        let IP = event.target.value;
        this.setState({ addInverterIP: IP });
    }

    handleEditInverterName(event) {
        let name = event.target.value;
        this.setState({ editInverterName: name });
    }

    handleEditInverterIP(event) {
        let IP = event.target.value;
        this.setState({ editInverterIP: IP });
    }

    handleEditInverterPowerOuput(event) {
        let powerOutput = event.target.value;
        this.setState({ editInverterPowerOutput: powerOutput });
    }


    canAddInverterClass() {
        if (!this.state.addInverterName || !this.state.addInverterIP) {
            return "disabled";
        }
        return "";
    }

    canEditInverterClass() {
        if (!this.state.editInverter || !this.state.editInverterName || !this.state.editInverterIP || !this.state.editInverterPowerOutput
            || this.state.editInverterPowerOutput === ''
            || (this.state.editInverter && this.state.editInverterName === this.state.editInverter.mName 
                && this.state.editInverterIP === this.state.editInverter.mIP
                && Number.parseInt(this.state.editInverterPowerOutput) === this.state.editInverter.mPowerOutput)) {
            return "disabled";
        }
        let output = this.state.editInverterPowerOutput;
        if (output < 0 || output > 100) {
            return "disabled";
        }
        return "";
    }

    getActionColumnDetails(inverter) {
        if (this.isOwner()) {
            return (
                <td style={{ width: '50px' }}>
                    <div className="btn-group btn-group-md">
                        <a href="#" className="btn btn-info" onClick={e => this.handleOpenEditInverterDialog(e, inverter)}><i className="fas fa-edit"></i></a>
                        <a href="#" className="btn btn-danger" onClick={e => this.handleOpenDeleteInverterDialog(e, inverter)}><i className="fas fa-trash"></i></a>
                    </div>
                </td>
            )
        }
    }

    getItems(inverter, idx) {
        let status = false;
        let energy = 0;
        let temp = 0;
        let acPower = 0;
        let inverter_current = null;
        let powerOutput = 100;
        if (inverter.current.length > 0) {
            inverter_current = inverter.current[0];
            status = inverter_current.mStatus;
            energy = inverter_current.mEnergy;
            temp = inverter_current.mTemp;
            acPower = inverter_current.mACpower;
        }
        if (inverter.mPowerOutput) {
            powerOutput = inverter.mPowerOutput;
        }
        status = this.getStatus(inverter_current, status);
        return (
            <tr key={inverter._id}>
                <td scope="row">
                    <Link to={"/inverter?id=" + inverter._id}>
                        <div>{inverter.mName}</div>
                    </Link>
                </td>
                <td scope="row">
                    {inverter.mIP}
                </td>
                <td>{this.drawStatus(status)}</td>
                <td>{this.formatNumberWithStatus(energy / 1000, status)}</td>
                <td>{this.formatNumberWithStatus(acPower / 1000, status)}</td>
                <td>{powerOutput}</td>
                <td>{this.formatNumberWithStatus(temp, status)}</td>
                {this.getActionColumnDetails(inverter)}
            </tr>
        );
    }

    getStatus(item, mStatus) {
        if (!mStatus || !item.mTime) {
            return false;
        }
        const now = moment();
        const statusTime = moment(item.mTime);

        const duration = now.diff(statusTime, 'minutes');

        if (duration > 15) {
            return false;
        }
        return true;
    }

    drawStatus(status) {
        if (status) {
            return (
                <span className="badge bg-success">ON</span>
            );
        }
        return (<span className="badge bg-danger">OFF</span>);
    }

    formatNumberWithStatus(number, status) {
        if (!status) {
            return 0;
        }
        return this.formatNumber(number);
    }

    formatNumber(number) {
        return Number(number).toFixed(1);
    }

    getActivatePowerOutputMessage() {
        let station = this.state.station;
        if (!station.mSupportChangePowerOutput) {
            return (
                <div className="form-group row">
                    <label className="col-sm-12 text-danger col-form-label">If you need to activate remote control function, please contact admin</label>
                </div>
            )
        }
    }

    getPowerOutputControl() {
        let station = this.state.station;
        if (station.mSupportChangePowerOutput) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Power Output (%)</label>
                    <div className="col-sm-8">
                        <input type="number" min="0" max="100" className="form-control" value={this.state.editInverterPowerOutput} onChange={this.handleEditInverterPowerOuput} />
                    </div>
                </div>);
        } else {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Power Output (%)</label>
                    <div className="col-sm-8">
                        <input type="number" min="0" max="100" className="form-control" value={this.state.editInverterPowerOutput} readOnly/>
                    </div>
                </div>);
        }
    }

    getAddInverterModal() {
        return (
            <Modal show={this.state.pendingAddInverter} onHide={this.handleCloseAddInverter} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Add inverter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.addInverterMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Name</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" placeholder="" value={this.state.addInverterName} onChange={this.handleAddInverterName} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">IP</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" placeholder="192.168.1.1" value={this.state.addInverterIP} onChange={this.handleAddInverterIP} />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseAddInverter}>
                        Close
                        </Button>
                    <Button variant="success" onClick={this.handleAddInverter} className={this.canAddInverterClass()}>
                        Add
                        </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    getEditInverterButtonFooter() {
        if (this.state.updatingEditInverter) {
            return (
                <Modal.Footer>
                    <Button variant="primary" className="disabled">
                        Updating...
                    </Button>
                </Modal.Footer>
            )
        } else {
            return (
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseEditInverter}>
                        Close
                        </Button>
                    <Button variant="primary" onClick={this.handleEditInverter} className={this.canEditInverterClass()}>
                        Update changes
                    </Button>
                </Modal.Footer>
            )
        }
    }

    getEditInverterModal() {
        return (
            <Modal show={this.state.pendingEditInverter} onHide={this.handleCloseEditInverter} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Edit inverter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.editInverterMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Name</label>
                            <div className="col-sm-8">
                                <input type="text" className="form-control" placeholder="" value={this.state.editInverterName} onChange={this.handleEditInverterName} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">IP</label>
                            <div className="col-sm-8">
                                <input type="text" className="form-control" placeholder="192.168.1.1" value={this.state.editInverterIP} onChange={this.handleEditInverterIP} />
                            </div>
                        </div>
                        {this.getPowerOutputControl()}
                        {this.getActivatePowerOutputMessage()}
                    </form>
                </Modal.Body>
                {this.getEditInverterButtonFooter()}
            </Modal>
        );
    }

    getDeleteConfimationMessage

    getDeleteInverterModal() {
        return (
            <Modal show={this.state.pendingDeleteInverter} onHide={this.handleCloseDeleteInverterDialog} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Delete inverter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {"Do you want to delete this inverter?"}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseDeleteInverterDialog}>
                        No
                        </Button>
                    <Button variant="danger" onClick={this.handleDeleteInverter}>
                        Yes
                        </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    getButtonBar() {
        if (this.isOwner()) {
            return (<div className="row d-flex justify-content-end mr-1">
                <div>
                    <button type="button" className="btn btn-block btn-success btn-md" onClick={this.handleOpenAddInverterDialog}>Add</button>
                </div>
            </div>)
        }
        return (
            <div></div>
        );
    }

    getEditInverterColumnHeader() {
        if (this.isOwner()) {
            return (
                <th scope="col"></th>
            )
        }
    }

    render() {
        const inverters = this.state.inverters;
        if (!inverters) {
            return (
                <h1>Loading...</h1>
            )
        }
        return (
            <div className="content-wrapper">
                <section className="content-header" />
                <section className="content">
                    <div className="container-fluid">
                        {this.getButtonBar()}
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered table-hover dataTable" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">IP</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Energy (MWh)</th>
                                        <th scope="col">ACPower (kW)</th>
                                        <th scope="col">Power Output (%)</th>
                                        <th scope="col">Temp (°C)</th>
                                        {this.getEditInverterColumnHeader()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getBody(inverters)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {this.getAddInverterModal()}

                    {this.getDeleteInverterModal()}

                    {this.getEditInverterModal()}
                </section>
                <ToastContainer />
            </div>
        )
    }
}